import { a as _objectSpread2 } from '../../_rollupPluginBabelHelpers-3b7bd988.js';

function getColumnsWithWidths(columns, totalWidth) {
  const updatedColumns = columns.map(column => {
    var _column$width;
    if ((_column$width = column.width) !== null && _column$width !== void 0 && _column$width.includes && column.width.includes('%')) {
      const widthNumber = parseInt(column.width, 10);
      const percentAsDecimal = widthNumber / 100;
      return _objectSpread2(_objectSpread2({}, column), {}, {
        width: Math.floor(percentAsDecimal * totalWidth)
      });
    }
    if (column.width) {
      return _objectSpread2(_objectSpread2({}, column), {}, {
        width: parseInt(column.width, 10)
      });
    }
    return _objectSpread2(_objectSpread2({}, column), {}, {
      width: null
    });
  });
  let totalDefinedWidth = 0;
  const columnsWithWidth = updatedColumns.filter(({
    width
  }) => width);
  columnsWithWidth.map(({
    width
  }) => width).forEach(width => {
    totalDefinedWidth += width;
  });
  const columnsWithoutWidthCount = updatedColumns.length - columnsWithWidth.length;
  const widthToFill = (totalWidth - totalDefinedWidth) / columnsWithoutWidthCount;
  return updatedColumns.map(column => column.width ? column : _objectSpread2(_objectSpread2({}, column), {}, {
    width: widthToFill
  }));
}

export { getColumnsWithWidths };
